import { Box, styled } from '@mui/material';
import { BRAND_GRADIENT } from '@presentation/styling/gradients';

export const Layout = styled('article')(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	gap: theme.spacing(3),
	padding: theme.spacing(2),
	[theme.breakpoints.up('md')]: {
		flexDirection: 'row',
		gap: theme.spacing(5),
		padding: theme.spacing(4),
		alignItems: 'flex-start',
	},
}));

export const ImageColumn = styled(Box)(({ theme }) => ({
	width: '100%',
	[theme.breakpoints.up('md')]: {
		maxWidth: '480px',
		flexShrink: 0,
	},
}));

export const PuzzleImage = styled('img')(() => ({
	width: '100%',
	aspectRatio: '1 / 1',
	objectFit: 'cover',
	borderRadius: '16px',
	display: 'block',
	background: BRAND_GRADIENT,
}));

export const PuzzleVideo = styled('video')(() => ({
	width: '100%',
	aspectRatio: '1 / 1',
	objectFit: 'cover',
	borderRadius: '16px',
	display: 'block',
	background: BRAND_GRADIENT,
}));

export const InfoColumn = styled(Box)(() => ({
	flex: 1,
	minWidth: 0,
}));

export const KeywordList = styled(Box)(({ theme }) => ({
	display: 'flex',
	flexWrap: 'wrap',
	gap: theme.spacing(1),
	margin: `${theme.spacing(2)} 0`,
}));

export const Stats = styled(Box)(({ theme }) => ({
	display: 'flex',
	gap: theme.spacing(2.5),
	color: theme.colors.descriptionText,
	fontSize: 14,
	fontWeight: 500,
	margin: `${theme.spacing(2.5)} 0`,
}));
